<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-inexorange hover:text-white" :href="route('exercises')">Repeteciones Ejercicio </inertia-link>
      <span class="text-white font-medium">/   {{ form.name}}
      </span>
    </h1>
    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
        <text-input v-if="this.name1" v-model="form.nivel1" class="pr-6 pb-8 w-full lg:w-1/6" :label="this.name1" />
        <text-input v-if="this.name2" v-model="form.nivel2" class="pr-6 pb-8 w-full lg:w-1/6" :label="this.name2" />
        <text-input v-if="this.name3!==''" v-model="form.nivel3" class="pr-6 pb-8 w-full lg:w-1/6" :label="this.name3" />
        <text-input v-if="this.name4!=''" v-model="form.nivel4" class="pr-6 pb-8 w-full lg:w-1/6" :label="this.name4" />
        <text-input v-if="this.name5" v-model="form.nivel5" class="pr-6 pb-8 w-full lg:w-1/6" :label="this.name5" />
        <text-input v-if="this.name6" v-model="form.nivel6" class="pr-6 pb-8 w-full lg:w-1/6" :label="this.name6" />
        <div class="pr-6 pb-8 w-full lg:w-6/6">
           <label style="color: white; font-weight: 700;" class="form-label" >Es tiempo:</label>
        <input  v-model="form.che" type="checkbox" class="pr-6 pb-8" label="Tiempo" />
  </div>
        </div>
        <div class="px-8 py-4 bg-transparent flex justify-between items-center">
          <loading-button :loading="form.processing" style="color: white" class="px-6 py-2 btn-indigoOrange" type="submit">Guardar</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import VueMultiselectComponent from 'vue-multiselect-component'
import FileInput from '@/Shared/FileInput'


export default {
  metaInfo() {
    return {
      title: `${this.form.name}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    FileInput,
    TrashedMessage,
    vSelect,
    VueMultiselectComponent
  },
  layout: Layout,
  props: {
    niveles: Array,
    exercise: Object
  },
  remember: 'form',
  data() {
    return {
      name1: '',
      name2: '',
      name3: '',
      name4: '',
      name5: '',
      name6: '',
      name7: '',
      niveless: this.niveles,
        form: this.$inertia.form({
        che: null,
        nivel1: 0,
        nivel2: 0,
        nivel3: 0,
        nivel4: 0,
        nivel5: 0,
        nivel6: 0,
        nivel7: 0,
        repeticiones: null,
        tiempo: null,
        name: this.exercise.name,
        id: this.exercise.id,
      }),
    }
  },
  mounted () {
   
    this.niveless.forEach(item => {
      if(item.nivel_id==1)
      {
        this.name1=item.name;
        if(item.repeticiones>0)
        {
          this.form.nivel1=item.repeticiones;
        }
        else{
          this.form.che = true;
          this.form.nivel1=item.tiempo;

        }
      }
       if(item.nivel_id==2)
      {
        this.name2=item.name;
        if(item.repeticiones>0)
        {
          this.form.nivel2=item.repeticiones;
        }
        else{
          this.form.nivel2=item.tiempo;

        }
      }
       if(item.nivel_id==3)
      {
        this.name3=item.name;
         if(item.repeticiones>0)
        {
          this.form.nivel3=item.repeticiones;
        }
        else{
          this.form.nivel3=item.tiempo;

        }
      }
       if(item.nivel_id==4)
      {
        this.name4=item.name;
        if(item.repeticiones>0)
        {
          this.form.nivel4=item.repeticiones;
        }
        else{
          this.form.nivel4=item.tiempo;

        }
      }
       if(item.nivel_id==5)
      {
        this.name5=item.name;
         if(item.repeticiones>0)
        {
          this.form.nivel5=item.repeticiones;
        }
        else{
          this.form.nivel5=item.tiempo;

        }
      }
       if(item.nivel_id=6)
      {
        this.name6=item.name;
        if(item.repeticiones>0)
        {
          this.form.nivel6=item.repeticiones;
        }
        else{
          this.form.nivel6=item.tiempo;

        }
      }
       if(item.nivel_id==7)
      {
        this.name7=item.name;
       if(item.repeticiones>0)
        {
          this.form.nivel7=item.repeticiones;
        }
        else{
          this.form.nivel7=item.tiempo;

        }
      }
    });
  },
  methods: {
    update() {
      this.form.put(this.route('exercisesR.update', this.exercise.id))
    },
  },
}
</script>
